<template>
    <b-card>
      <div slot="header">
          <i class="icon-layers" aria-hidden="true"></i>
            <b> {{ reformatType }}</b> : {{ topic }}
      </div>
      <div id="details">
        <small v-b-tooltip.hover  title="Created By">
         <i class="fa fa-user color-blue" aria-hidden="true"></i> {{ createdBy }}
        </small>
        <small v-b-tooltip.hover  title="Created Date">
         <i class="fa fa-clock-o color-blue" aria-hidden="true"></i>
         {{ createdAtText }}
        </small>
        <a href="#" v-b-tooltip.hover  :title="detailsText">
          <i class="fa fa-question-circle-o" aria-hidden="true"></i>
        </a>
      </div>
      <b-row>
        <b-col cols="12">
        <div id="editor"></div>
        </b-col>
      </b-row>

      <div slot="footer" v-if="editorMode">
        <b-button :disabled="!isActive" @click="saveDocument" class="mr-2" type="submit" size="sm" variant="primary">
          <i class="fa fa-dot-circle-o"></i>
          Save
        </b-button>
        <b-button :disabled="!isActive" v-b-modal.confirmDelete v-if="$route.params.id" type="reset" size="sm" variant="danger">
          <i class="fa fa-ban"></i>
            Delete
        </b-button>
        <transition name="custom-classes-transition"
                enter-active-class="animated fadeInLeft"
                leave-active-class="animated zoomOut" mode="out-in">
          <label v-if="isLoading" class="saving">Saving  <b-spinner small label="Small Spinner" type="grow"></b-spinner></label>
          <label v-else-if="isSuccess" class="saved">Saved.</label>
          <label v-else-if="isError" class="error">{{ errorMessage }}</label>
        </transition>

        <alert-confirm
            :id="'confirmDelete'"
            @confirm="deleteDocument">
            confirm to delete ?
          </alert-confirm>
      </div>

    </b-card>
</template>

<script>
import InlineEditor from '@ckeditor/ckeditor5-build-inline/build/ckeditor';
import { CustomUploadAdapterPlugin } from '../../assets/utils/editor-upload';
import { reformatDate } from '../../assets/utils/formatter';
import AlertConfirm from '../../components/alert/AlertConfirm';
import { setTimeout } from 'timers';

export default {
  data () {
    return {
      type: 'Architecture',
      topic: 'Overall',
      editor: null,
      createdAt: '',
      createdBy: '',
      updatedAt: '',
      updatedBy: '',
      isActive: true,
      isLoading: false,
      isSuccess: null,
      isError: null,
      errorMessage: ''
    };
  },
  methods: {
    createEditor (id) {
      InlineEditor
        .create(document.querySelector(id), {
          extraPlugins: [CustomUploadAdapterPlugin],
          placeholder: 'Content of the editor.',
          image: {
            toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],
            styles: [
              'full',
              'alignLeft',
              'alignRight'
            ]
          },
          uploadUrl: process.env.VUE_APP_URL_DOCS_API + '/docs/upload' // custom plugin
        })
        .then(newEditor => {
          this.editor = newEditor;
          this.editor.isReadOnly = !this.editorMode;
          this.setEditorData();
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    setEditorData () {
      const id = this.$route.params.id;
      this.axios.get(process.env.VUE_APP_URL_DOCS_API + '/docs/' + id)
        .then(response => {
          const data = response.data.data.docs[0] || null;
          if (data) {
            const content = data.content;
            this.type = data.type;
            this.topic = data.topic;
            this.createdBy = data.createdBy;
            this.createdAt = data.createdAt;
            this.updatedBy = data.updatedBy;
            this.updatedAt = data.updatedAt;
            this.editor.setData(content);
          }
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    saveDocument () { // only update document
      this.isLoading = true;
      this.isSuccess = null;
      this.isError = null;
      const id = this.$route.params.id;
      if (id) {
        const data = { content: this.editor.getData() };
        this.axios.patch(process.env.VUE_APP_URL_DOCS_API + '/docs/' + id, data)
          .then(response => {
            this.isSuccess = true;
          })
          .catch(error => {
            this.handleError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    deleteDocument () {
      const id = this.$route.params.id;
      this.isActive = false;
      this.axios.delete(process.env.VUE_APP_URL_DOCS_API + '/docs/' + id)
        .then(response => {
          this.$router.replace({ name: 'docs-home' });
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    handleError (error) {
      this.isError = true;
      setTimeout(() => { this.isError = null; this.errorMessage = ''; }, 2000);
      this.errorMessage = error.response ? error.response.data.message : error.message;
    }
  },
  computed: {
    editorMode () {
      return this.$store.getters.editorMode;
    },
    reformatType () {
      if ('architecture' === this.type) {
        return 'Architecture';
      } else if ('deployment' === this.type) {
        return 'Deployment';
      } else if ('api' === this.type) {
        return 'Sequence & API';
      } else if ('installation' === this.type) {
        return 'Installation';
      } else if ('toturial' === this.type) {
        return 'Tutorials';
      } else {
        return this.type;
      }
    },
    detailsText () {
      return `created by ${this.createdBy} 
              ${reformatDate(this.createdAt)} 
              last update by ${this.updatedBy}
              ${reformatDate(this.updatedAt)}`;
    },
    createdAtText () {
      return reformatDate(this.createdAt);
    },
    updatedAtText () {
      return reformatDate(this.updatedAt);
    }
  },
  components: {
    AlertConfirm
  },
  watch: {
    editorMode (mutation) {
      this.editor.isReadOnly = !mutation;
    },
    '$route' () {
      this.setEditorData();
    },
    isSuccess () {
      if (this.isSuccess) {
        setTimeout(() => { this.isSuccess = null; }, 1000);
      }
    }
  },
  mounted () {
    this.createEditor('#editor');
  },
  destroyed () {
    this.editor.destroy(); // protect alert error rect-source-not-in-dom
  }
};
</script>

<style scoped>
    .ck-content {
        min-height:200px;
    }
    #details {
      margin-top: -20px;
      font-size: 13px;
    }
    .color-blue{
      color:#63c2de;
    }
    .saving{
      margin-left: 5px;
      font-size: 13px;
      color: #20c997;
    }
    .saved{
      margin-left: 5px;
      font-size: 13px;
      color: #4dbd74;
    }
    .error{
      margin-left: 5px;
      font-size: 13px;
      color: #f86c6b;
    }
</style>

<style>
  figcaption{
      display: none;
    }
  .ck .ck-widget__selection-handler{
      display: none;
  }
  table{
      width: 100%;
    }
</style>
